import { preloadSpaceViews } from '@confluence/space-views/entry-points/preloadSpaceViews.ts';
import { preloadContentTypesHeader } from '@confluence/content-types-header/entry-points/preloadContentTypesHeader.js';
import { preloadShortcutsSmartLinks } from '@confluence/space-shortcuts/entry-points/preloadShortcutsSmartLinks.ts';
import { preloadSideNavigation } from '@confluence/side-navigation/entry-points/preloadSideNavigation.ts';
import { preloadSpaceGuestList } from '@confluence/space-guest-list/entry-points/preloadSpaceGuestList.ts';
import { preloadEmbedData } from '@confluence/confluence-embeds/entry-points/preloadEmbedData.ts';
import { preloadShareAndRestrictButtonQuery } from '@confluence/share-and-restrict-dialog/entry-points/preloadShareAndRestrictButtonQuery.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { fg } from '@confluence/feature-gating';
import { expValEquals } from '@confluence/feature-experiments';
import { preloadContentMode } from '@confluence/editor-content-mode-button/entry-points/preloadContentMode.ts';

export const preloadEmbedRoute = async (
	match: RouteMatch,
	_url: string,
	isTransition: boolean = false,
) => {
	const { isLicensed } = getPreloaderFnContext();
	const tasks: Promise<any>[] = [];
	const { spaceKey, contentId } = match.params;

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		tasks.push(
			preloadSideNavigation(spaceKey),
			preloadSpaceGuestList(spaceKey),
			preloadShortcutsSmartLinks(spaceKey),
		);
	} else if (!isTransition) {
		tasks.push(preloadSpaceViews(spaceKey, isLicensed));
	}

	// Content types header (object header)
	if (fg('confluence_frontend_content_wrapper')) {
		tasks.push(preloadContentTypesHeader(contentId, fg('confluence_frontend_content_wrapper')));
		// (No need to call preloadPageRestrictionsQuery() here; the item's restriction data will be
		//  loaded by preloadEmbedData() below)
	}

	if (
		expValEquals('confluence_compact_text_format', 'isEnabled', true) ||
		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		(expValEquals('cc_editor_ai_content_mode', 'variant', 'test') &&
			fg('platform_editor_content_mode_button_mvp'))
	) {
		tasks.push(preloadContentMode({ contentId, isDraft: false, useCache: true }));
	}

	// Unified Share and Restrict Button
	if (fg('confluence_frontend_usd_ssr')) {
		tasks.push(preloadShareAndRestrictButtonQuery(contentId));
	}

	tasks.push(preloadEmbedData(spaceKey, contentId));

	return waitForAllReturnWhenError(tasks);
};
